import Vue from "vue";
import Vuex from "vuex";
import organization from "./store/organization";
import organizationSettings from "./store/organizationSettings";
import profile from "./store/profile";
import documents from "./store/documents";
import vacancy from "./store/vacancy";
import news from "./store/news";
import announcement from "./store/announcement";
import about from "./store/about";
import token from "./store/token";
import accounts from "./store/accounts";
import alerts from "./store/alerts";
import requests from "./store/requests";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    organization,
    token,
    organizationSettings,
    profile,
    documents,
    vacancy,
    news,
    announcement,
    about,
    accounts,
    alerts,
    requests
  },
  state: {},
  mutations: {},
  actions: {}
});
